<div class="contract-delete-panel" data-testid="contract-delete-panel">
    @if (isLinked) {
        <div class="alert alert-warning" role="status" id="contract-delete-warning" data-testid="contract-delete-warning">
            <p class="mb-1">This contract cannot be deleted while it is linked to organisations.</p>
            <ul class="mb-0">
                @for (link of linkedOrganisations; track link.id) {
                    <li>{{ link.organisation.name }}</li>
                }
            </ul>
            <p class="mb-0 mt-2">Unlink them in the Organisations tab.</p>
        </div>
    }
    <button type="button" class="btn btn-outline-danger"
            data-testid="contract-delete"
            [disabled]="isLinked || deleting"
            [attr.aria-describedby]="isLinked ? 'contract-delete-warning' : null"
            confirmHeader="Confirm the action"
            confirmModal="Are you sure you want to delete this contract?"
            confirmMessage="The contract is kept in the database but cannot be restored or edited. Its code is freed so it can be reused."
            confirmOk="Yes, proceed"
            confirmCancel="No, cancel"
            confirmOkClass="btn-outline-danger"
            confirmCancelClass="btn-gray text-dark"
            [confirmCancelFirst]="true"
            (confirmedClick)="delete()">
        <i class="bi bi-trash me-2" aria-hidden="true"></i>Delete contract
    </button>
</div>
